<template>
  <div>
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item>Produtos</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Produtos Termoteria</h1>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="itens"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)" >
          <el-table-column prop="id" label="Id" width="60" sortable></el-table-column>
          <el-table-column prop="sge_cliente" label="SGE Cliente" width="105"></el-table-column>
          <el-table-column prop="cod_nbr" label="Cód NBR" width="115" sortable></el-table-column>
          <el-table-column prop="cod_fornecedor" label="Cód Fornecedor" width="160" sortable></el-table-column>
          <el-table-column prop="descricao" label="Descrição" sortable></el-table-column>
          <el-table-column prop="modelo" label="Modelo" width="170" sortable></el-table-column>
          <el-table-column prop="valor" label="Valor" width="100" align="right" header-align="right"></el-table-column>
        </el-table>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      files: [],
      loading: true,
      falso: false,
      verdadeiro: true,
      labelPosition: "right",
      itens: [],
      permissao: {},
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      ruleForm: {
        titulo: "",
        descricao: "",
        show: true, //1
      },
      ruleFormEdit: {
        titulo: "",
        descricao: "",
        id: "",
        show: false, //0
      },
      rules: {
        titulo: [
          {
            required: true,
            message: "Por Favor, informe o Título",
            trigger: "blur",
          },
          {
            min: 3,
            message: "Deve ter pelo menos 3 caracteres",
            trigger: "blur",
          },
        ],
        descricao: [
          { required: true, message: "Informe a Descrição", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.loading = true;
    axios
      .get(url + "/produtos/", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        this.itens = response.data;
        this.loading = false;
        for (var i = 0; i < this.itens.length; i++) {
          if (this.itens[i].mostra == 1) {
            this.itens[i].mostra = true;
          } else {
            this.itens[i].mostra = false;
          }
        }
      })
      .catch((err) => {
        this.itens = "erro" + err;
      });
  },
  methods: {
    getDados() {
      this.loading = true;
      axios
        .get(url + "/avisos/", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.itens = response.data;
          this.loading = false;
          for (var i = 0; i < this.itens.length; i++) {
            if (this.itens[i].mostra == 1) {
              this.itens[i].mostra = true;
            } else {
              this.itens[i].mostra = false;
            }
          }
        })
        .catch((err) => {
          this.itens = "erro" + err;
        });
    },
  },
};
</script>

<style>
.el-row-topo {
  margin-top: 10px;
}
</style>
